import phisicalPerson from './phisicalPerson'
import juridicPerson from './juridicPerson'
import report from './report'

export default [
  ...phisicalPerson,
  ...juridicPerson,
  ...report,
]
